import { Box, FormHelperText } from '@mui/material';

import { Text } from 'common';

export function PrimaryCareProviderFormFields() {
  return (
    <Box>
      <Text>No configuration required</Text>
      <FormHelperText>
        Extract Patient&apos;s Primary Care Providers from Notable databases.
      </FormHelperText>
    </Box>
  );
}
